import { render, staticRenderFns } from "./FormTextArea.vue?vue&type=template&id=1293b81c&scoped=true&"
import script from "./FormTextArea.vue?vue&type=script&lang=js&"
export * from "./FormTextArea.vue?vue&type=script&lang=js&"
import style0 from "./FormTextArea.vue?vue&type=style&index=0&id=1293b81c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1293b81c",
  null
  
)

export default component.exports